import { createContext, useState } from "react";


export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [socketData, setSocketData] = useState(null);

  return (
    <SocketContext.Provider value={{ socketData, setSocketData }}>
      {children}
    </SocketContext.Provider>
  );
};
